// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"81":"ecd8e871","383":"3102a511","488":"277a5191"}[chunkId] + ".chunk.js");